import { DataLayerItem } from "../typings/gtm";

/** @deprecated */
export const trackGoogleEvent = (eventCategory: string, eventAction: string, eventLabel: string) => {
  //@ts-ignore
  if(window.ga) {
    //@ts-ignore
    window.ga('gtm1.send', 'event', eventCategory, eventAction, eventLabel);
  }
}

export const pushGTMEvent = (data: DataLayerItem) => {
  if (!Array.isArray(window.dataLayer)) {
    console.error('dataLayer not found')
    return
  }

  window.dataLayer.push(data)
}

